module.exports = __webpack_public_path__ + "static/media/assembly.bd308adf.png";